import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { take } from 'rxjs/operators';
import { FormularioService } from 'src/app/services/formulario.service';
import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from 'src/app/services/notification.service';
import { FilterDetailComponent } from 'src/app/shared/filter-detail/filter-detail.component';
import { FilterPc003EstrategiaComponent } from './filter-pc003-estrategia/filter-pc003-estrategia.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalCommentPc003Component } from './modal-comment-pc003/modal-comment-pc003.component';
import { UserService } from '../../service/user.service';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { SimpleModalComponent } from 'src/app/shared/simple-modal/simple-modal.component';
import { Pc003Service } from '../../service/pc003.service';

@Component({
  selector: 'app-list-pc003-estrategia',
  templateUrl: './list-pc003-estrategia.component.html',
  styleUrls: ['./list-pc003-estrategia.component.scss']
})
export class ListPc003EstrategiaComponent implements OnInit {
  public displayedColumns?: string[] = [
    "Hibrido", "Comentario", "#"];

  public dataSource?: MatTableDataSource<any> = new MatTableDataSource([]);
  public dataFilters?: Array<any> = new Array<any>();
  public pageSizeOptions?: number[] = [];
  public formulario: FormGroup;
  public areaSelect: string = localStorage.getItem('area-select') || null;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(FilterDetailComponent, { static: false }) filterDetailComponent: FilterDetailComponent;
  @ViewChild(FilterPc003EstrategiaComponent, { static: false }) filterPc003EstrategiaComponent: FilterPc003EstrategiaComponent;
  adm: boolean = false;

  constructor(protected generalService: GeneralService,
    protected formularioService: FormularioService,
    protected pc003Service: Pc003Service,
    protected notificationService: NotificationService, public dialog: MatDialog, private service: UserService) { }

  ngOnInit(): void {
    this.getData()
  }

  showFilter(): void {
    this.filterDetailComponent.showMenu(true);
  }

  private getColumnsList(): string[] {
    return [
      "pc_hibrido",
      "comment"

    ];
  }
  async getData(): Promise<void> {
    const status = await this.generalService.getConnectionStatus();
    const data_offline = await this.generalService.getDataFromLocalStorage('pc003');
    if (status) {
      if (data_offline?.length > 0) {
        await this.setData('pc003', this.getColumnsList(), 'pc003', true, data_offline);
      } else {
        await this.setData('pc003', this.getColumnsList(), 'pc003', false, data_offline);
      }
    }
  }
  async getFilter(filter): Promise<void> {
    // tslint:disable-next-line: max-line-length
    await this.formularioService.getAllFilter('pc003', { filters: filter, columns: this.getColumnsList() }).pipe(take(1)).toPromise().then(async (response: any) => {
      this.dataFilters = filter;
      await this.configDataTable(response?.data);
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, error.message);
    });
  }
  private async setData(sheet?: string, columnsList?: string[], fileName?: string, blMakeConcat?: boolean, data_offline?: []): Promise<any> {
    let result = [];
    // tslint:disable-next-line: max-line-length
    await this.formularioService.getAllFilter(sheet, { columns: columnsList }).pipe(take(1)).toPromise().then((response: any) => {
      if (blMakeConcat) {
        result = data_offline.concat(response?.data);
      } else {
        result = response?.data;
      }
      this.configDataTable(result);
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, error.message);
      this.configDataTable(await this.generalService.getDataFromLocalStorage(fileName));
    });
  }



  configDataTable(lista: Array<any>): void {
    this.dataSource = new MatTableDataSource(lista);
    this.dataSource.paginator = this.paginator;
    this.dataSource.paginator._intl.firstPageLabel = this.formularioService.firstPageLabel;
    this.dataSource.paginator._intl.lastPageLabel = this.formularioService.lastPageLabel;
    this.dataSource.paginator._intl.itemsPerPageLabel = this.formularioService.itemsPerPageLabel;
    this.dataSource.paginator._intl.nextPageLabel = this.formularioService.nextPageLabel;
    this.dataSource.paginator._intl.previousPageLabel = this.formularioService.previousPageLabel;
    // tslint:disable-next-line: max-line-length
    this.paginator._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) { return `0 de ${length}`; }
      length = Math.max(length, 0); const startIndex = page * pageSize;
      const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length)
        // tslint:disable-next-line: align
        : startIndex + pageSize; return `${startIndex + 1} – ${endIndex} de ${length}`;
    };
    this.dataSource.sort = this.sort;
  }


  public async openDialog(data, isEdit, isDelete) {
    let input = {
      title: 'Excluír Cometário',
      titleBtn1: 'Não',
      titleBtn2: 'Sim',
      mensage: 'Deseja realmente excluír esse Comentário do Híbrido: ' + data?.pc_hibrido + '?',

    };
    const dialogRef = this.dialog.open(ModalCommentPc003Component, {
      data: {
        pc003: data ?? { id: null, pc_hibrido: null, comment: null },
        isEdit,
        isDelete,
        ...input
      }
    });

    await dialogRef.afterClosed().subscribe(x => {
      if (x.save) {
        if (!isDelete) {
          this.pc003Service.saveCommentPc003(x.data).pipe(take(1)).toPromise().then(async (response: any) => {
            this.notificationService.sendNotification('', !isEdit ? TypeMessage.New : TypeMessage.Edit, ActionMessage.Success);
            var filterValues = Object.values(this.dataFilters);
            if (filterValues.some((value) => value !== null && value !== undefined && value !== '' && value.length > 0)) {

              this.getFilter(this.dataFilters);
            }
            else {
              this.getData();
            }
          }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
          });
        } else {
          this.pc003Service.deleteCommentPc003(x.data.id).pipe(take(1)).toPromise().then(async (response: any) => {
            this.notificationService.sendNotification('', TypeMessage.Delete, ActionMessage.Success);
            var filterValues = Object.values(this.dataFilters);
            if (filterValues.some((value) => value !== null && value !== undefined && value !== '' && value.length > 0)) {

              this.getFilter(this.dataFilters);
            }
            else {
              this.getData();
            }
          }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
          });
        }


      }




    })
  }


}
